module.exports = __webpack_public_path__ + "img/weingutloewenstein_1.fd9ac860.jpg";